var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('LogoImg'),_c('NavBar'),_c('NavMobile'),_c('GradientMap'),_c('SectionTitle',{attrs:{"sectionTitle":_vm.contact_us,"padding":'section-title--padding-top'}}),_c('ContactComponent'),_c('MapComponent'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }